module.exports = __webpack_public_path__ + "media/media/product-card/accessory-3-14b47e1ab4e992243f98cc8169777c29.png";